import { IIoCContainer } from '@lmnop/web-core';
import { IWebsiteCoreSettings } from '@lmnop/website-core';
import { CoreModulesIoC } from './core-modules-ioc.class';
import { IExtendedCookieService } from '../extended-cookie-service/extended-cookie-service.interface';

export interface IAngularWebsiteCoreIoCContainer extends IIoCContainer {
    core: CoreModulesIoC;
    settings: IWebsiteCoreSettings;

    cookieService: IExtendedCookieService;
}
